import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { AwardJapanStandard } from '@travel/icons/award';
import JapanStandardPopup from '@travel/traveler-core/components/JapanStandardPopup';
import { useDeviceType, useTranslation, MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import { RakutenAward } from '@travel/ui';
import { cx, isNotEmptyArray } from '@travel/utils';

import { getDetailSummary } from 'store/providerInformation/selectors';

import styles from './japanQualityAndAward.module.scss';

type Props = {
  /** String defining current provider id */
  pageIdentifier: string;
  wrapperClassName?: string;
};

const JapanQualityAndAward = (props: Props) => {
  const { pageIdentifier, wrapperClassName } = props;

  const detailSummary = useSelector(getDetailSummary(pageIdentifier));
  const { awards, isJapanStandard } = detailSummary;

  const [showJapanStandardPopup, setShowJapanStandardPopup] = useState(false);

  const isMobile = useDeviceType() === MOBILE_SCREEN;

  const japanStandardPopupAriaLabel = useTranslation({
    id: 'Traveler_Common.Japan_Quality.Name',
  });

  const rakutenAwards = awards
    ? awards
        .filter(award => award.image)
        .map(award => (
          <RakutenAward
            key={award?.name}
            title={award?.name}
            image={award?.image}
            imageClassName={styles.awardImage}
            data-testid="providerInformation-japanQualityAndAward-firstAward"
          />
        ))
    : [];

  const shouldDisplayJapanQualityAndAward = Boolean(
    isNotEmptyArray(rakutenAwards) || isJapanStandard,
  );

  return shouldDisplayJapanQualityAndAward ? (
    <div
      className={cx(styles.awardWrapper, wrapperClassName)}
      data-testid="providerInformation-japanQualityAndAward-wrapper"
    >
      <JapanStandardPopup
        isOpen={showJapanStandardPopup}
        isUsedForSEO={true}
        onCloseCallback={() => setShowJapanStandardPopup(false)}
      />
      {isJapanStandard && (
        <button
          data-testid="providerInformation-japanQualityAndAward-japanStandardAward"
          aria-label={japanStandardPopupAriaLabel}
          className={styles.japanStandardAward}
          onClick={_event => setShowJapanStandardPopup(true)}
        >
          <AwardJapanStandard />
        </button>
      )}
      {isMobile ? rakutenAwards[0] : rakutenAwards}
    </div>
  ) : null;
};

export default JapanQualityAndAward;
